module.exports = {
   name: 'Product Requirements',
   wizard: {
      actionBtn: 'Save',
      action: 'add_product_requirements',
      pages: [
         {
            title: 'Product Requirements',
            subtitle: 'Configure a new product requirement',
            forms: [
               {
                  type: 'text', form_type: 'text', label: 'Name', model: 'name',
                  validation: 'required|min:3|max:150', class: 'col-12'
               },
               {
                  type: 'text', form_type: 'text', label: 'Code', model: 'code',
                  validation: 'required|min:1|max:50', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Label', model: 'label',
                  validation: 'required|min:1|max:150', class: 'col-12'
               },
               {
                  type: 'select', class: 'col-12 col-md-6', model: 'type',
                  options: [
                     { val: 'ATTACHMENT', label: 'Attachment' },
                     { val: 'TEXT', label: 'Text' },
                  ], validation: 'required', label: 'Type'
               },
               {
                  type: 'textarea', form_type: 'text', label: 'Description', model: 'description',
                  validation: 'required|min:10|max:500', class: 'col-12'
               },
            ],
         }
      ]
   },
   table: {
      title: 'Product Requirements',
      subtitle: 'A list of configured insurance classes',
      table_fields: [
         { name: 'Code', align: 'l' },
         { name: 'Name', align: 'l' },
         { name: 'Label', align: 'l' },
         { name: 'Actions', align: 'c' }
      ],
      searchFields: ["code", "name", "min_account_bal", "max_account_bal"],
      rowData: [
         { type: 'text', field: 'code', class: 'left bolder small' },
         { type: 'text', field: 'name', class: 'left bolder' },
         { type: 'text', field: 'label', class: 'left bolder small' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               {
                  type: 'menu', title: 'Edit', event: 'client:edit', icon: 'ico-right', params: [
                     { key: 'client', field: '*' }
                  ]
               },
               {
                  type: 'menu', title: 'View', event: 'client:view', icon: 'ico-reply', params: [
                     { key: 'email', field: 'email' },
                     { key: 'name', field: 'name' }
                  ]
               },
               // {type: 'divider'},
               {
                  type: 'menu', title: 'Delete', event: 'client:delete', icon: 'ico-mail-a', params: [
                     { key: 'email', field: 'email' }
                  ]
               },
            ]
         },
      ]
   },
}